<template>
  <div class="GlobalMarket">
    <div class="banner">
      <img class="img-100" src="@/assets/img/guoji/banner.png" alt srcset />
    </div>
    <div class="container">
      <div class="row justify-center">
        <div class="market">
          <el-tabs class v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="国内市场" name="1">
              <div class="recommend text-indent">聚焦新零售医疗，以临床切入，提供儿童呼吸疾病物联网解决方案，服务全国近百家医疗机构。</div>

              <div class="conference">
                <div class="title">参与会议</div>

                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente"
                    v-for="(item,index) in conferenceBannerList"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="conference">
                <div class="title">参加展会</div>

                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente"
                    v-for="(item,index) in conferenceBannerListzhanhui"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="conference">
                <div class="title">入驻医院</div>

                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente"
                    v-for="(item,index) in hospitalList"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="conference">
                <div class="title">考察来访</div>

                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente"
                    v-for="(item,index) in kaochaList"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-tab-pane>
            <el-tab-pane label="国际市场" name="2">
              <div class="map">
                <img class="img-100" src="@/assets/img/guoji/ma.png" alt srcset />
              </div>
              <div
                class="recommend text-indent"
              >未来移动医疗一直放眼于全球市场的拓展，目前我司的雾化器产品已出口到：美国，德国、波兰、爱沙尼亚等欧洲国家，韩国、印度、阿联酋、沙特阿拉伯、约旦、巴基斯坦、马来西亚、菲律宾等亚洲国家，澳大利亚，以及哥伦比亚、厄瓜多尔、多米尼加共和国、巴拿马等拉美国家均已建立稳定的战略合作关系。未来移动医疗在德国MEDICA、美国FIME、迪拜ARAB HEALTH等国际医疗展会上已广受瞩目。</div>

              <div class="conference">
                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente item"
                    v-for="(item,index) in guojiList"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="conference">
                <el-carousel :interval="4000" indicator-position="none" type="card" height="300px">
                  <el-carousel-item
                    class="flex justify-center align-cente item"
                    v-for="(item,index) in guojiList2"
                    :key="index"
                  >
                    <div
                      class="flex justify-center align-center flex-direction article"
                      @click="jump(item)"
                    >
                      <img class="img" :src="item.imgUrl" alt srcset />
                      <div class="name">{{item.name}}</div>
                      <div class="date">{{item.date}}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      conferenceBannerList: [
        {
          imgUrl: require("../../assets/img/anhui/anhui.png"),
          name: "智雾化·新未来高峰论坛 安徽站",
          date: "2020/06/23",
          subImgList: [
            require("../../assets/img/anhui/xiangqing/1.jpg"),
            require("../../assets/img/anhui/xiangqing/2.jpg"),
            require("../../assets/img/anhui/xiangqing/3.jpg"),
            require("../../assets/img/anhui/xiangqing/4.jpg"),
            require("../../assets/img/anhui/xiangqing/5.jpg"),
            require("../../assets/img/anhui/xiangqing/6.jpg"),
            require("../../assets/img/anhui/xiangqing/7.jpg"),
            require("../../assets/img/anhui/xiangqing/8.jpg")
          ],
          video: "http://cdn.yirdoc.com.cn/anhui.mp4"
        },
        {
          imgUrl: require("../../assets/img/hebei/hebei.png"),
          name: "智雾化·新未来高峰论坛 河北站",
          date: "2020/06/19",
          subImgList: [
            require("../../assets/img/hebei/xiangqing/1.jpg"),
            require("../../assets/img/hebei/xiangqing/2.jpg"),
            require("../../assets/img/hebei/xiangqing/3.jpg"),
            require("../../assets/img/hebei/xiangqing/4.jpg"),
            require("../../assets/img/hebei/xiangqing/5.jpg")
          ],
          video: "http://cdn.yirdoc.com.cn/hebei.mp4"
        },
        {
          imgUrl: require("../../assets/img/guangdong/guangdong.png"),
          name: "智雾化·新未来高峰论坛 广东站",
          date: "2020/06/16",
          subImgList: [
            require("../../assets/img/guangdong/xiangqing/1.jpg"),
            require("../../assets/img/guangdong/xiangqing/2.jpg"),
            require("../../assets/img/guangdong/xiangqing/3.jpg"),
            require("../../assets/img/guangdong/xiangqing/4.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/jiangsu/jiangsu.png"),
          name: "智雾化·新未来高峰论坛 江苏站",
          date: "2020/06/13",
          subImgList: [
            require("../../assets/img/jiangsu/xiangqing/img (1).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (2).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (3).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (4).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (5).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (6).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (7).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (8).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (9).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (10).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (11).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (12).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (13).jpg"),
            require("../../assets/img/jiangsu/xiangqing/img (14).jpg")
          ],
          video: "http://cdn.yirdoc.com.cn/MyVideo_2.mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/ninahui.png"),
          name: "山东省儿童哮喘协作组年会",
          date: "2017/08/26",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20170826/img1.jpeg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20170826/img2.jpeg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20170826/img3.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/20180423.png"),
          name: "山东儿童哮喘行动计划启动会",
          date: "2018/04/23",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (1).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (2).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (3).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (4).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (5).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180423/img (6).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/20180630.png"),
          name: "“物联你我，舒畅未来”，儿童哮喘物联网管理峰会",
          date: "2018/06/30",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (1).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (2).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (3).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (4).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (5).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (6).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (7).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (8).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (9).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (10).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (11).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20180630/img (12).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/20190314.png"),
          name: "布咳乐春季专家计划",
          date: "2019/03/14",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (1).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (2).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (3).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (4).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (5).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (6).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (7).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (8).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190314/img (9).jpg")
          ]
        },

        {
          imgUrl: require("../../assets/img/guoneihuiyi/20190702.png"),
          name: "安徽省儿科主任会议",
          date: "2019/07/02",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20190702/img (1).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190702/img (2).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190702/img (3).jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190702/img (4).jpg")
          ]
        }
      ],

      conferenceBannerListzhanhui: [
        {
          imgUrl: require("../../assets/img/guoneihuiyi/CMEF-kunming.png"),
          name: "CMEF秋季昆明",
          date: "2017/10/28",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20171028/img1.jpeg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20171028/img2.jpeg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20171028/img3.jpeg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/boao.png"),
          name: "博鳌健康大会",
          date: "2019/05/10",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20190510/img1.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/CMEF-shanghai.png"),
          name: "CMEF春季上海",
          date: "2019/05/14",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20190514/img1.jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20190514/img2.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneihuiyi/CMEF-qingdao.png"),
          name: "CMEF秋季青岛",
          date: "2019/10/19",
          subImgList: [
            require("../../assets/img/guoneihuiyi/xiangqing/20191019/img1.jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20191019/img2.jpg"),
            require("../../assets/img/guoneihuiyi/xiangqing/20191019/img3.jpg")
          ]
        }
      ],
      hospitalList: [
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/guangzhou_ranminzhonglu.png"),
          name: "广州市妇女儿童医疗中心人民中路院区",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/guangzhou/42741593507939_.pic_hd.png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/guangzhou/42751593507940_.pic_hd.png")
          ],
          video: "http://cdn.yirdoc.com.cn/guanzhou_zhonglu.mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/guangzhou_xincheng.png"),
          name: "广州市妇女儿童医疗中心珠江新城院区",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/guangzhou/guangzhou_xincheng (1).png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/guangzhou/guangzhou_xincheng (2).png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/guangzhou/guangzhou_xincheng (3).png")
          ],
          video: "http://cdn.yirdoc.com.cn/guangzhou_xincheng (1).mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/hebei_yikee2.png"),
          name: "河北医科大学第二医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/hebei/hebei.png")
          ],
          video: "http://cdn.yirdoc.com.cn/hebei1.mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/kaifeng_ertong.png"),
          name: "开封市儿童医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/kaifeng/kaifeng.png")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/nanjing_yike.png"),
          name: "南京医科大学第四附属医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/nanjing/nanjing.png")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/qingdao_shili_dong.png"),
          name: "青岛市市立医院东院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/qingdao/shili_dong (1).png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/qingdao/shili_dong (2).png")
          ],
          video: "http://cdn.yirdoc.com.cn/shili_dong (1).mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/qingdao_shili_xi.png"),
          name: "青岛市市立医院西院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/qingdao/shili_xi.png")
          ],
          video: "http://cdn.yirdoc.com.cn/shili_xi.mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/shandong_qilu_ertong.png"),
          name: "山东大学齐鲁儿童医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/qiluertong/qiluertong.png")
          ],
          video: "http://cdn.yirdoc.com.cn/qiluertong.mp4"
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/zhengzhou_daxue_fuzhu.png"),
          name: "郑州大学第一附属医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/zhengzhou/zhegnzhou (1).png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/zhengzhou/zhegnzhou (2).png"),
            require("../../assets/img/guoneiyiyuan/xiangqing/zhengzhou/zhegnzhou (3).png")
          ],
          video: "http://cdn.yirdoc.com.cn/zhengdayi.mp4"
        },

        {
          imgUrl: require("../../assets/img/guoneiyiyuan/anyang.png"),
          name: "安阳妇幼保健院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/anyangfuyou.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/fuyang.png"),
          name: "阜阳二院儿科门诊大厅",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/fuyang2.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/guiyi.png"),
          name: "贵医附三院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/gui3.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/henanchanghong.png"),
          name: "河南长宏医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/henan.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/jiangyin.png"),
          name: "江阴中医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/jiangyin.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/shanxiertong.png"),
          name: "陕西省儿童医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/shanxiertong.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/shanxirenmin.png"),
          name: "陕西省人民医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/shanxirenmin.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoneiyiyuan/shouguanghexin.png"),
          name: "寿光和信医院",
          subImgList: [
            require("../../assets/img/guoneiyiyuan/xiangqing/shouganghexin.jpg")
          ]
        }
      ],
      kaochaList: [
        {
          imgUrl: require("../../assets/img/kaocha/CIPLA.png"),
          name: "接待CIPLA（西普拉）二位科学家",
          subImgList: [
            require("../../assets/img/kaocha/xiangqing/CIPLA/img (1).jpg"),
            require("../../assets/img/kaocha/xiangqing/CIPLA/img (2).jpg"),
            require("../../assets/img/kaocha/xiangqing/CIPLA/img (3).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/kaocha/laoshan.png"),
          name: "崂山区政府领导来访考察",
          subImgList: [
            require("../../assets/img/kaocha/xiangqing/laoshan/img (1).jpg"),
            require("../../assets/img/kaocha/xiangqing/laoshan/img (2).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/kaocha/Cipla (1).png"),
          name: "印度第二大药企Cipla",
          subImgList: [
            require("../../assets/img/kaocha/xiangqing/Cipla1/img (1).jpg"),
            require("../../assets/img/kaocha/xiangqing/Cipla1/img (2).jpg")
          ]
        }
      ],
      guojiList: [
        {
          imgUrl: require("../../assets/img/guoji/Hospitalar.png"),
          name: "巴西Hospitalar展会",
          date: "2018",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Hospitalar/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/Hospitalar/img2.jpg"),
            require("../../assets/img/guoji/xiangqing/Hospitalar/img3.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/Chennai2018.png"),
          name: "Chennai2018年印度医疗设备展会",
          date: "2018",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Chennai2018/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/Chennai2018/img2.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/Medtrade2018.png"),
          name: "Medtrade2018年美国亚特兰大秋季展会",
          date: "2018",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Medtrade2018/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/Medtrade2018/img2.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/MEDICA2018.png"),
          name: "德国MEDICA2018展会",
          date: "2018",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/MEDICA2018/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/MEDICA2018/img2.jpg"),
            require("../../assets/img/guoji/xiangqing/MEDICA2018/img3.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/ARAB-HEALTH2018.png"),
          name: "迪拜ARAB HEALTH 2018",
          date: "2018",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/ARAB-HEALTH2018/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/ARAB-HEALTH2018/img2.jpg"),
            require("../../assets/img/guoji/xiangqing/ARAB-HEALTH2018/img3.jpg"),
            require("../../assets/img/guoji/xiangqing/ARAB-HEALTH2018/img4.jpg"),
            require("../../assets/img/guoji/xiangqing/ARAB-HEALTH2018/img5.jpg")
          ]
        }
      ],
      guojiList2: [
        {
          imgUrl: require("../../assets/img/guoji/2019-01-Arab-Health.png"),
          name: "迪拜Arab Health展会",
          date: "2019/01",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Arab-Health/img1.jpg"),
            require("../../assets/img/guoji/xiangqing/Arab-Health/img2.jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/Medical-Fair-India.png"),
          name: "印度Medical Fair India 2019展会",
          date: "2019/02",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (1).jpg"),
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (2).jpg"),
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (3).jpg"),
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (4).jpg"),
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (5).jpg"),
            require("../../assets/img/guoji/xiangqing/Medical-Fair-India/img (6).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/Expomed-Eurasia.png"),
          name: "土耳其Expomed Eurasia",
          date: "2019/03 ",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/Expomed-Eurasia/img (1).jpg"),
            require("../../assets/img/guoji/xiangqing/Expomed-Eurasia/img (2).jpg"),
            require("../../assets/img/guoji/xiangqing/Expomed-Eurasia/img (3).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/FIME.png"),
          name: "美国FIME展会",
          date: "2019/06 ",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/FIME/img (1).jpg"),
            require("../../assets/img/guoji/xiangqing/FIME/img (2).jpg"),
            require("../../assets/img/guoji/xiangqing/FIME/img (3).jpg"),
            require("../../assets/img/guoji/xiangqing/FIME/img (4).jpg"),
            require("../../assets/img/guoji/xiangqing/FIME/img (5).jpg")
          ]
        },
        {
          imgUrl: require("../../assets/img/guoji/MEDICA.png"),
          name: "德国MEDICA 2019展会",
          date: "2019/11",
          subImgList: [
            require("../../assets/img/guoji/xiangqing/MEDICA2019/img (1).jpg"),
            require("../../assets/img/guoji/xiangqing/MEDICA2019/img (2).jpg"),
            require("../../assets/img/guoji/xiangqing/MEDICA2019/img (3).jpg")
          ]
        }
      ]
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    jump(item) {
      this.$router.push({
        path: "/details",
        query: {
          data: JSON.stringify(item)
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.el-tabs__item.is-active {
  color: #0d9c91;
}

.el-tabs__active-bar {
  background-color: #0d9c91;
}

.market {
  width: 100%;
  padding-top: 40px;
}

.recommend {
  font-size: 14px;
  margin-top: 20px;
  padding: 0 20px;
}

.map {
  width: 70%;
  margin: 0 15%;
  text-align: center;
  padding: 20px 0;
}

.conference {
  .title {
    text-align: center;
    padding: 60px 0 20px 0;
    font-size: 22px;
    font-weight: bold;
  }
  .item {
    background: #fff;
  }
}
.article {
  background: #fff;
  .img {
    width: 100%;
  }
  .name {
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    padding: 2px 0;
  }
  .date {
    width: 100%;
    text-align: left;
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .conference {
    .title {
      text-align: center;
      padding: 40px 0 0 0;
    }
  }
}
</style>

<style>
.el-tabs__item {
  font-size: 18px;
  font-weight: bold;
}
.el-tabs {
  width: 100%;
}
.el-tabs__nav {
  display: flex;
  justify-content: center;
}
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #0d9c91;
}

.el-tabs__active-bar {
  background-color: #0d9c91;
}

.el-tabs__nav-wrap::after {
  background-color: #fff;
}

.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
</style>